import React from 'react';
import s from './SearchWindow.module.css';
import searchIcon from '../../assets/img/icons/akar-icons_search.svg';
import {useTranslation} from 'react-i18next';

type Props = {
	handleClick?: any;
	value?: string;
	handleChange?: any;
	handleSubmit?: any;
};
const SearchWindow: React.FC<Props> = ({handleClick, handleChange, value}) => {
	const {t} = useTranslation();
	return (
		<div className={s.searchInput}>
			<label>
				<input
					value={value}
					onChange={handleChange}
					type="text"
					placeholder={t('Введіть текст для пошуку...')}
					className={s.searchInputField}
				/>
				<button onClick={handleClick} type={'button'} className={s.searchIcon}>
					<img src={searchIcon} alt="searchIcon" />
				</button>
			</label>
		</div>
	);
};

export default SearchWindow;
